import { useSelector } from 'react-redux'
import config from 'config'
import { selectAccountSubdomain } from 'ducks/accounts/selectors/selectAccountSubdomain'
import useAccountFeatureFlag from 'util/hooks/useAccountFeatureFlag'
import { isHelplyWidgetEnabled } from 'util/helplyWidget'

/**
 * Which Helply support chat this account gets here — what the loader and the help icon both read. `widget`: the new
 * one, behind its gate (provisioned environment, account allowlist, the helply-agent-ready preference). `legacy`:
 * the legacy agent embed the templates carry, for a flagged account the gate leaves out — what it has today.
 * Neither: the Groove widget.
 */
const useHelplyWidgetEnabled = () => {
  const ready = useAccountFeatureFlag('helply-agent-ready')
  const subdomain = useSelector(selectAccountSubdomain)
  const widget = isHelplyWidgetEnabled({
    ready,
    subdomain,
    widget: config.helplyWidget,
  })
  return { widget, legacy: Boolean(ready && !widget) }
}

export default useHelplyWidgetEnabled
